import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private state: Map<string, any> = new Map();
  private subjects: Map<string, BehaviorSubject<any>> = new Map();
  private firstTimeLoaded = new BehaviorSubject<boolean>(false);

  constructor() {}

  setValue(key: string, value: any): void {
    this.state.set(key, value);
    if (this.subjects.has(key)) {
      this.subjects.get(key).next(value);
    } else {
      this.subjects.set(key, new BehaviorSubject(value));
    }
  }

  getValue(key: string): any {
    return this.state.get(key);
  }

  getValueObservable(key: string): Observable<any> {
    if (!this.subjects.has(key)) {
      this.subjects.set(key, new BehaviorSubject(this.state.get(key)));
    }
    return this.subjects.get(key).asObservable();
  }

  setFirstTimeLoaded(): void {
    this.firstTimeLoaded.next(true);
  }

  waitForFirstTimeLoaded(): Observable<boolean> {
    return this.firstTimeLoaded.asObservable().pipe(
      filter((loaded) => loaded === true),
      take(1)
    );
  }
}
